<template>
    <div class="m-1 mb-0" :style="skin.main_leagues.body" style="overflow:hidden">
        <div class="p-2 d-flex" :style="skin.main_leagues.header">
            <div style="width: 20%;">
                <span> {{translate("main_leagues")}}</span>
            </div>
            <div class="d-flex" style="width: 80%;">
                <div style="width: 90%;"></div>
                <div class="mx-3" v-for="(deporte,index) in ligas.sports" v-bind:key="index" style="cursor:pointer"
                :class="deporte.id == 1 ? 'nav_active': ''"
                @click="sport=deporte.id"
                >
                    <div :title="deporte.name" class="icon_futbol" style="width:20px;height:20px" v-if="deporte.id==1"></div>
                    <div :title="deporte.name" class="icon_hockey" style="width:20px;height:20px" v-else-if="deporte.id==2"></div>
                    <div :title="deporte.name" class="icon_basket" style="width:20px;height:20px" v-else-if="deporte.id==3"></div>
                    <div :title="deporte.name" class="icon_tenis" style="width:20px;height:20px" v-else-if="deporte.id==4"></div>
                    <div :title="deporte.name" class="icon_beisball" style="width:20px;height:20px" v-else-if="deporte.id==11||deporte.id==104"></div>
                    <div :title="deporte.name" class="icon_futsal" style="width:20px;height:20px" v-else-if="deporte.id==26 || deporte.id==24"></div>
                    <div :title="deporte.name" class="icon_tenis_mesa" style="width:20px;height:20px" v-else-if="deporte.id==41"></div>
                    <div :title="deporte.name" class="icon_eGames" style="width:20px;height:20px" v-else-if="deporte.id==73||deporte.id==74||deporte.id==75||deporte.id==76||deporte.id==77||deporte.id==80||deporte.id==82||deporte.id==83||deporte.id==71||deporte.id==158||deporte.id==260||deporte.id==208||deporte.id==185"></div>
                    <div :title="deporte.name" class="icon_basket" style="width:20px;height:20px" v-else-if="deporte.id==205"></div>
                    <div :title="deporte.name" class="icon_badminton" style="width:20px;height:20px" v-else-if="deporte.id==9"></div>
                    <div :title="deporte.name" class="icon_balon_mano" style="width:20px;height:20px" v-else-if="deporte.id==29"></div>
                    <div :title="deporte.name" class="icon_rugby" style="width:20px;height:20px" v-else-if="deporte.id==37"></div>
                    <div :title="deporte.name" class="icon_snoker" style="width:20px;height:20px" v-else-if="deporte.id==39"></div>
                    <div :title="deporte.name" class="icon_dardos" style="width:20px;height:20px" v-else-if="deporte.id==22"></div>
                    <div :title="deporte.name" class="icon_volleyball" style="width:20px;height:20px" v-else-if="deporte.id==14"></div>
                    <div :title="deporte.name" class="icon_cricket" style="width:20px;height:20px" v-else-if="deporte.id==19"></div>
                    <div :title="deporte.name" class="icon_waterpolo" style="width:20px;height:20px" v-else-if="deporte.id==42"></div>
                    <div :title="deporte.name" class="icon_golf" style="width:20px;height:20px" v-else-if="deporte.id==27"></div>
                    <div :title="deporte.name" class="icon_rugby1" style="width:20px;height:20px" v-else-if="deporte.id==36"></div>
                    <div :title="deporte.name" class="icon_volleyball" style="width:20px;height:20px" v-else-if="deporte.id==5"></div> 
                    <div :title="deporte.name" class="icon_futAmericano" style="width:20px;height:20px" v-else-if="deporte.id==6"></div> 
                    <div :title="deporte.name" class="icon_futbol_australiano" style="width:20px;height:20px" v-else-if="deporte.id==8"></div>
                    <div :title="deporte.name" class="icon_boxeo" style="width:20px;height:20px" v-else-if="deporte.id==17"></div>
                    <div :title="deporte.name" class="icon_ciclismo" style="width:20px;height:20px" v-else-if="deporte.id==21"></div>
                    <div :title="deporte.name" class="icon_race" style="width:20px;height:20px" v-else-if="deporte.id==25 || deporte.id==33 || deporte.id==32 || deporte.id==101"></div>
                    <div :title="deporte.name" class="icon_mma" style="width:20px;height:20px" v-else-if="deporte.id==44"></div>
                    <div :title="deporte.name" class="icon_hurling" style="width:20px;height:20px" v-else-if="deporte.id==70"></div>
                    <div :title="deporte.name" class="icon_squash" style="width:20px;height:20px" v-else-if="deporte.id==88"></div>
                    <div :title="deporte.name" class="icon_specials" style="width:20px;height:20px" v-else-if="deporte.id==90"></div>
                    <div :title="deporte.name" class="icon_specials" style="width:20px;height:20px" v-else></div>
                </div>
            </div>
        </div>
        <div class="row p-2">
            <div
                v-for="(liga,index) in ligas.leagues"
                v-bind:key="index"
                class="col-3 mb-2 my-2 text-center"
                style="cursor:pointer"
                @click="select_liga(liga)"
            >
                <div class="p-1" :style="selected.includes(liga.id)?skin.main_leagues.league_item_selected:skin.main_leagues.league_item">
                    <div :style="selected.includes(liga.id)?skin.main_leagues.league_item_selected_inner:skin.main_leagues.league_item"> 
                        <span>{{ liga.country_name }}. {{ liga.name }}</span>
                    </div>
                </div>
            </div>
        </div>
        <ligasPrematch3
            v-bind:skin="skin"
            v-bind:language="language"
            v-bind:translation="translation"
        >
        </ligasPrematch3>
    </div>
</template>

<script>
const flags = require('../../../../assets/countries.json');
import ligasPrematch3 from '../../prematch2/ligas_prematch3.vue';
export default {
    name:"main_ligas",
    props:["skin","translation","language"],
    components:{ligasPrematch3},
    data(){
        return{
            ligas_id:[2988,2985,566,1861,543,548,1834,538,545,541,1792
            ],
            ligas_countries:["Brazil","Colombia"],
            selected:[],
            counterSelections:0,
            sport:1
        }
    },
    methods:{
        translate(text) {
            if (this.$props.translation[text]) {
                return this.$props.translation[text][this.$props.language];
            }
            return text;
        },
        select_liga(data){
            //this.$store.dispatch('setLobbyView','prematch2_ligas2');
            if(this.selected.includes(data.id)){
                this.selected.splice(this.selected.indexOf(data.id),1);
            }
            else{
                //this.selected.push(data.id);
                this.selected=[data.id];
            }
            let payload = {
                league:data.id,
                country:data.country_id,
                league_name:data.name,
                country_name:data.country,
                sport_id:1,
                sport_name:this.translate(data.sport_name),
                multiple:false
            };
            this.$store.dispatch('prematch_2/add_remove_liga',payload);
        },
        country_flag(pais) {
          let flag = ""
          flags.countries.forEach(country => {
              if(country.name_es == pais || country.name_en == pais){
                  flag = country.code.toLowerCase()
              }
          });
          return flag;
      }, 
    },
    computed:{
        ligas(){
            var list={
                leagues:[],
                sports:{}
            };
            let sports = this.$store.getters['prematch_2/getSports'];
            if(this.$props.skin.main_leagues.target_leagues){
                this.ligas_id = this.$props.skin.main_leagues.target_leagues;
            }
            Object.keys(sports).forEach(sport=>{
                let data = sports[sport];
                if(data ? (data.region ? true : false) : false){
                    Object.keys(data.region).forEach(region=>{
                        this.ligas_id.forEach(liga_id=>{
                            if(data.region[region].competition ? true : false ){
                                if(liga_id in data.region[region].competition){
                                    data.region[region].competition[liga_id].country = data.region[region].name;
                                    data.region[region].competition[liga_id].country_alias = data.region[region].alias;
                                    data.region[region].competition[liga_id].country_name = data.region[region].name;
                                    data.region[region].competition[liga_id].sport_id = data.id;
                                    data.region[region].competition[liga_id].sport_name = data.alias;
                                    list.leagues.push(data.region[region].competition[liga_id]);
                                }
                                if(liga_id in data.region[region].competition){
                                    list.sports[data.id] = {id:data.id};
                                }
                            }
                        }); 
                    });
                }
            })
            if(this.counterSelections<1 && list.leagues.length>0){
                this.select_liga(list.leagues[0]);
                this.counterSelections++;
            }
            return list;
        },
    }
}
</script>

<style>

</style>